import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainControlSummary, postDomainControlExport } from '../actions';
import { ENABLE_DISABLE_DOMAIN_POPUP, REPORT_GENERATION_STATUSES } from '../constants';
import { allDomainSummariesSelector, reportGenerationStatusSelector } from '../selectors';
import { DomainReportHelpCenterLink } from '../shared_components/info_links';
import { openPopup, setDomainForPopup } from '../slice';
import { CardLoader, Row } from './shared_styles';
const labelCss = "l1cg6gnz";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
export const CardVerified = ({
  domain
}) => {
  const dispatch = useDispatch();
  const allDomainSummaries = useSelector(allDomainSummariesSelector);
  const domainSummary = allDomainSummaries[domain.uuid];
  const reportGenerationStatus = useSelector(reportGenerationStatusSelector(domain.uuid));
  const onEnableDomainControlClick = () => {
    dispatch(setDomainForPopup(domain));
    dispatch(openPopup(ENABLE_DISABLE_DOMAIN_POPUP));
  };
  const onChangeCheckbox = event => {
    event.stopPropagation();
  };
  const generateReport = () => {
    dispatch(postDomainControlExport(domain));
  };
  useEffect(() => {
    if (domainSummary) {
      return;
    }
    dispatch(getDomainControlSummary(domain));
  }, [dispatch, domain, domainSummary]);
  if (!domainSummary) {
    return <CardLoader />;
  }
  return <div>
      <Row>
        <BodyText weight="bold">{I18n.t('publisher.organization_settings.domain_control.cards.verified.summary_title')}</BodyText>
        <BodyText>
          {domainSummary.count === 1 ? HtmlParser(I18n.t('publisher.organization_settings.domain_control.cards.verified.summary_text_singular'), {
          DomainReportHelpCenterLink
        }) : HtmlParser(I18n.t('publisher.organization_settings.domain_control.cards.verified.summary_text', {
          count: domainSummary.count
        }), {
          DomainReportHelpCenterLink
        })}
        </BodyText>
        <MinimalButton fontSize="medium" onClick={() => generateReport()} disabled={[REPORT_GENERATION_STATUSES.generated, REPORT_GENERATION_STATUSES.pending].includes(reportGenerationStatus)}>
          {reportGenerationStatus === REPORT_GENERATION_STATUSES.pending ? I18n.t('publisher.organization_settings.domain_control.cards.verified.generate_report_pending') : I18n.t('publisher.organization_settings.domain_control.cards.verified.generate_report')}
        </MinimalButton>
      </Row>
      <Row>
        <BodyText weight="bold">{I18n.t('publisher.organization_settings.domain_control.cards.verified.domain_enablement_title')}</BodyText>
        <BodyText>
          {domain.enforced ? I18n.t('publisher.organization_settings.domain_control.cards.verified.domain_enablement_description.enabled') : I18n.t('publisher.organization_settings.domain_control.cards.verified.domain_enablement_description.disabled')}
        </BodyText>
        <Label>
          <SwitchInput checked={domain.enforced} onClick={onEnableDomainControlClick} onChange={onChangeCheckbox} />
          <BodyText inline color="muted">
            {domain.enforced ? I18n.t('publisher.organization_settings.domain_control.cards.verified.domain_enablement_control.enabled') : I18n.t('publisher.organization_settings.domain_control.cards.verified.domain_enablement_control.disabled')}
          </BodyText>
        </Label>
      </Row>
    </div>;
};
CardVerified.propTypes = {
  domain: PropTypes.shape({
    domain: PropTypes.string.isRequired,
    enforced: PropTypes.bool,
    last_checked_at: PropTypes.string,
    state: PropTypes.string,
    uuid: PropTypes.string.isRequired,
    verification_method: PropTypes.string.isRequired,
    verification_code: PropTypes.string
  }).isRequired
};

require("./verified.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./verified.js");